import { IAggFuncParams, IRowNode } from 'ag-grid-community'

const toNumber = (value: unknown): number => {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

const pickChildValue = (child: IRowNode, field: string) =>
  child.aggData?.[field] ?? child.data?.[field]

export const customAggFuncs = {
  customSum: (params: IAggFuncParams) => {
    let sum: number = 0

    if (
      params.rowNode.group &&
      params.rowNode.childrenAfterGroup?.length === 1
    ) {
      if (!isNaN(params.values[0])) sum += Number(params.values[0])
    } else {
      params.rowNode.childrenAfterGroup?.forEach(
        (child: IRowNode, index: number) => {
          // Groups with only one child should take the value of that child (instead of summing to 0)
          if (params.values[index]) {
            if (
              params.rowNode.level === 0 &&
              child.childrenAfterGroup?.[0].data.parentAggregateAmount === 1
            ) {
              if (!isNaN(params.values[index]))
                sum += Number(params.values[index])
            }

            // For level 1 groups, if the child has a non-zero aggregateAmount, use the child's value instead of summing to 0
            if (
              params.rowNode.level === 1 &&
              child.data?.aggregateAmount !== 0
            ) {
              if (!isNaN(params.values[index]))
                sum += Number(params.values[index])
            }
          }
        }
      )
    }
    return sum
  },
  customDiffPrognosis: (params: IAggFuncParams) => {
    // For group nodes, calculate diff as (sum current prognosis) - (sum previous prognosis)
    if (params.rowNode.group) {
      let totalPrognosis = 0
      let previousPrognosis = 0
      let hasPreviousValues = false
      params.rowNode.childrenAfterGroup?.forEach((child: IRowNode) => {
        totalPrognosis += toNumber(pickChildValue(child, 'totalPrognosis'))
        const prevValue = pickChildValue(child, 'previousTotalPrognosis')

        if (prevValue !== null && prevValue !== undefined) {
          hasPreviousValues = true
          previousPrognosis += toNumber(prevValue)
        }
      })

      // Only return difference if there are previous values to compare with
      if (!hasPreviousValues) {
        return null
      }

      const isKostnader =
        params.rowNode.key?.toUpperCase() === 'KOSTNADER' ||
        params.rowNode.parent?.key?.toUpperCase() === 'KOSTNADER'

      return isKostnader
        ? previousPrognosis - totalPrognosis
        : totalPrognosis - previousPrognosis
    }

    // For leaf nodes, return the pre-calculated difference value from data
    const leafDifference = params.rowNode?.data?.difference
    if (leafDifference !== undefined && leafDifference !== null) {
      return toNumber(leafDifference)
    }

    // If no value, return null (empty)
    return null
  },
}
